import { render } from "./NewsAreaComponent.vue?vue&type=template&id=6d68a4fe&ts=true"
import script from "./NewsAreaComponent.vue?vue&type=script&lang=ts"
export * from "./NewsAreaComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__